export function headerScrollCss() {
    if (!document.getElementById('header'))
    return;

    const header = document.getElementById('header'); 

    if (window.scrollY > 500) {
        header.classList.add("light-mode");
    }
    else {
        header.classList.remove("light-mode");
    }

    let lastScrollY = window.scrollY;
    window.addEventListener('scroll', function () {
        if (window.scrollY > 15) {
            if (window.scrollY < lastScrollY) {
                header.classList.add('sticky');
                header.classList.remove('hidden');
            } else {
                header.classList.remove('sticky');
                header.classList.add('hidden');
            }
            lastScrollY = window.scrollY;
        }
    });
}